module.exports = __webpack_public_path__ + "img/jdb.7036760f.png";